<template>
    <div class="relative">
        <div class="">
            <div class="relative z-1 px-1">
                <div class="cut-off-corner h-4 w-10 bg-red-500 px-2" />
                <p class="absolute bottom-0 text-3xl !leading-[1.3] font-bold text-shadow-lg">
                    {{ icon }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            required: true,
            type: String,
        },
    },
}
</script>

<style>
.cut-off-corner {
    clip-path: polygon(8px 0, 100% 0, 100% 100%, 0 100%, 0 8px);
}
</style>
